import { PersistanceService } from '@shared/services/persistance.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { CountdownComponent } from 'ngx-countdown';
import { AuthService } from '@api/auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent implements OnInit {
  hide = true;
  loading = false;
  authStepOne: FormGroup = this.fb.group({
    email: ['', Validators.required],
    password: ['', Validators.required],
  });

  authStepTwo: FormGroup = this.fb.group({
    phone: ['', Validators.required],
  });

  authStepThree: FormGroup = this.fb.group({
    code: ['', Validators.required],
  });

  @ViewChild('countdown') counter: CountdownComponent

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthService,
    private persistanceService: PersistanceService,
  ) {}

  ngOnInit() {}

  checkAuth() {
    this.authService.signIn(this.authStepOne.value).subscribe(
      res => {
        this.persistanceService.set('token', res.admin.access_token);
        this.router.navigate(['/'] , { replaceUrl: true } );
      },
      err => {
        this.loading = false
      },
      () => {
        this.loading = false;
      }
    )
  }

}
